import React, { useEffect, useState, useRef } from 'react';
import style from './RelatedSites.scss';
import _ from 'lodash';
import { RelatedSitesSkeleton } from '../../Skeletons/skeletons';
import { relatedSiteClick } from '../../../LoggerFactory/BiAnalyticsLogger/events';
import { LOGGER_TYPES } from '../../../LoggerFactory/loggerTypes';
import { LoggerContext } from '../../../appContext/LoggerProvider';
import { RelatedSitesDropDown } from './RelatedSitesDropDown';
import { RelatedSitesLinks } from './RelatedSitesLinks';

export const RelatedSites = ({ links }) => {
  const ref = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [wasMounted, setWasMounted] = useState(false);
  const [relatedSitesLinksWidth, setRelatedSitesLinksWidth] = useState(0);
  const { logger } = React.useContext(LoggerContext);

  useEffect(() => {
    const toggleRenderedComponent = (relatedSitesLinksElement) => {
      if (relatedSitesLinksElement && !relatedSitesLinksWidth) {
        setRelatedSitesLinksWidth(relatedSitesLinksElement.clientWidth);
      }

      if (relatedSitesLinksWidth) {
        const twoThirdsOfWindowScreen = window.innerWidth * 0.66; // related sites container width
        setShowDropdown(relatedSitesLinksWidth > twoThirdsOfWindowScreen);
      }
    };
    const handler = () => {
      toggleRenderedComponent(ref.current);
    };
    const throttled = _.throttle(handler, 300);
    window.addEventListener('resize', throttled);
    handler();
    if (!wasMounted) {
      setWasMounted(true);
    }

    return () => window.removeEventListener('resize', throttled);
  }, [wasMounted, relatedSitesLinksWidth]);

  const sendBiEventWhenClickOnRelatedSite = (selected_name, selected_url) => {
    logger.getLogger(LOGGER_TYPES.ANALYTICS_BI).log(relatedSiteClick, {
      selected_name,
      selected_url,
    });
  };

  const onSelectedSite = (option) => {
    sendBiEventWhenClickOnRelatedSite(option.value, option.id);
    return (location.href = option.id);
  };

  if (!wasMounted) {
    return (
      <span className={style.skeletonContainer}>
        <RelatedSitesSkeleton
          key="related-site-skeleton"
          className={style.relatedSiteSkeleton}
        />
      </span>
    );
  }

  return showDropdown ? (
    <RelatedSitesDropDown links={links} onSelectedSite={onSelectedSite} />
  ) : (
    <nav
      className={style.relatedSitesLinks}
      ref={ref}
      onClick={() => console.dir(ref.current)}
    >
      <RelatedSitesLinks
        links={links}
        sendBiEventWhenClickOnRelatedSite={sendBiEventWhenClickOnRelatedSite}
      />
    </nav>
  );
};
